import {
    GET_PRODUCT_TYPE_DEF,
    GET_PRODUCT_TYPE_DEF_SUCCESS,
    PRODUCT_TYPE_DEF_API_ERROR
} from "./actionTypes"

export const getProductTypeDefList = () => ({
    type: GET_PRODUCT_TYPE_DEF,
})

export const getProductTypeDefListSuccess = record => ({
    type: GET_PRODUCT_TYPE_DEF_SUCCESS,
    payload: record,
})

export const productTypeDefApiError = error => {
    return {
        type: PRODUCT_TYPE_DEF_API_ERROR,
        payload: error,
    }
}
